// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="position: relative;" v-click-outside="resetSearch">
    <div style="display: flex; align-items: center;">
      <span v-if="luckyError"
        style="color: #ffffff; font-size: 13px; margin-right: 10px; min-width: 180px; display: inline-block;">{{
          luckyError }}</span>
      Recentrer sur mon diamant étoile
      <v-btn small text @click="mystar" :title="$t('Recentrer sur mon diamant étoile.')" :ripple="false"
        style="margin: 0 2px 0 2px; min-width: 0; padding: 0 6px; color: #1976d2; display: flex; align-items: center;">
        <img src="@/assets/images/lucky.png" alt="Lucky" style="height: 36px; margin-right: 6px;" />
      </v-btn>

      <v-icon style="margin-right: 8px; color: #1976d2; cursor: pointer;">mdi-magnify</v-icon>
      <div style="position: relative; flex: 1;">
        <v-text-field :label="$t('Search...')" v-model="searchText" @keyup.native.esc="resetSearch()" hide-details
          single-line style="width: 100%;" />
        <div v-if="showList" class="search-dropdown">
          <v-list dense two-line :style="listStyle">
            <v-list-item v-for="(source, idx) in autoCompleteChoices" :key="source.names?.[0] || idx"
              @click="sourceClicked(source)">
              <v-list-item-action>
                <img :src="iconForSkySource(source)" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ nameForSkySource(source) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swh from '@/assets/sw_helpers.js'
import vClickOutside from 'v-click-outside'
import _ from 'lodash'
import { EventBus } from '@/event-bus.js'

export default {
  data: function () {
    return {
      autoCompleteChoices: [],
      searchText: '',
      lastQuery: undefined,
      luckyLevel: '',
      luckyLevels: [
        { label: 'Votre niveau d\'éclat idéal', value: '' },
        { label: 'Elégance (0,3 carat)', value: '1' },
        { label: 'Etincelance (0,5 carat)', value: '2' },
        { label: 'Splendeur (1 carat)', value: '3' },
        { label: 'Opulence', value: '4' }
      ],
      luckyConstellation: '',
      luckyConstellations: [
        { label: 'Votre constellation', value: '' },
        { label: 'Bélier', value: 'Bélier' },
        { label: 'Taureau', value: 'Taureau' },
        { label: 'Gémeaux', value: 'Gémeaux' },
        { label: 'Cancer', value: 'Cancer' },
        { label: 'Lion', value: 'Lion' },
        { label: 'Vierge', value: 'Vierge' },
        { label: 'Balance', value: 'Balance' },
        { label: 'Scorpion', value: 'Scorpion' },
        { label: 'Sagittaire', value: 'Sagittaire' },
        { label: 'Capricorne', value: 'Capricorne' },
        { label: 'Verseau', value: 'Verseau' },
        { label: 'Poissons', value: 'Poissons' },
        { label: 'Autre', value: 'other' }
      ],
      showHistory: false,
      luckyStarsSet: [],
      luckyStarsSetIndex: 0,
      luckyError: ''
    }
  },
  props: ['value', 'floatingList'],
  watch: {
    searchText: function () {
      console.log(`[${Date.now()}] searchText changed:`, this.searchText)
      if (this.searchText === '') {
        this.autoCompleteChoices = []
        this.lastQuery = undefined
        return
      }
      this.refresh()
    }
  },
  computed: {
    listStyle: function () {
      return this.floatingList ? 'position: absolute; z-index: 1000; margin-top: 8px' : ''
    },
    showList: function () {
      return this.searchText !== ''
    },
    canNavigateLuckySet() {
      return this.luckyStarsSet && this.luckyStarsSet.length > 1
    }
  },
  methods: {
    sourceClicked: function (val) {
      this.$emit('input', val)
      this.resetSearch()
    },
    resetSearch: function () {
      this.searchText = ''
    },
    refresh: _.debounce(function () {
      var that = this
      let str = that.searchText
      str = str.trim().replace(/\s+/g, ' ')
      str = str.toUpperCase()
      const encodedStr = encodeURIComponent(str)
      const now = Date.now()
      if (this.lastQuery === encodedStr) {
        return
      }
      this.lastQuery = encodedStr
      const queryAtRequestTime = encodedStr
      swh.querySkySources(encodedStr, 10).then(results => {
        const nowThen = Date.now()
        if (queryAtRequestTime !== that.lastQuery) {
          console.log(`[${nowThen}] Cancelled query: ${queryAtRequestTime}`)
          return
        }
        that.autoCompleteChoices = results
      }, err => { console.log(err) })
    }, 300),
    nameForSkySource: function (s) {
      if (s.title && s.title.title1) {
        return s.title.title1
      }
      const cn = swh.cleanupOneSkySourceName(s.match)
      const n = swh.nameForSkySource(s)
      if (cn === n) {
        return n
      } else if (n) {
        return cn + ' (' + n + ')'
      } else if (s.names && s.names.length) {
        return s.names[0]
      } else {
        return s.match || 'Inconnu'
      }
    },
    typeToName: function (t) {
      return swh.nameForSkySourceType(t)
    },
    iconForSkySource: function (s) {
      return swh.iconForSkySource(s)
    },
    luckySearch: function (typeId) {
      // Si appelé par un event natif (clic), typeId est un événement DOM
      if (typeId && typeof typeId === 'object' && (typeId instanceof Event || typeId instanceof PointerEvent)) {
        typeId = undefined
      }
      // Prépare les paramètres pour luckySkySource
      console.log('luckySearch avec typeId:', typeId)
      const params = {}
      if (typeId) {
        params.range = typeId
      }
      if (this.luckyLevel) {
        params.range = this.luckyLevel
      }
      if (this.luckyConstellation) {
        params.constellation = this.luckyConstellation
      }
      this.luckyError = '' // Reset erreur avant recherche
      swh.luckySkySource(params).then(result => {
        if (Array.isArray(result) && result.length > 0) {
          this.luckyStarsSet = result
          this.luckyStarsSetIndex = 0
          localStorage.setItem('luckyStarsSet', JSON.stringify(result))
          localStorage.setItem('luckyStarsSetIndex', '0')
          this.showLuckyStarAtIndex(0)
        } else if (result && result.match) {
          // fallback pour compatibilité
          this.luckyStarsSet = [result]
          this.luckyStarsSetIndex = 0
          localStorage.setItem('luckyStarsSet', JSON.stringify([result]))
          localStorage.setItem('luckyStarsSetIndex', '0')
          this.showLuckyStarAtIndex(0)
        } else {
          this.luckyStarsSet = []
          this.luckyStarsSetIndex = 0
          this.luckyError = 'Aucune étoile trouvée pour ces critères.'
          localStorage.setItem('luckyStarsSet', '[]')
          localStorage.setItem('luckyStarsSetIndex', '0')
        }
      }).catch(err => {
        this.autoCompleteChoices = []
        this.searchText = ''
        this.luckyError = 'Erreur lors de la recherche.'
        console.error('Erreur luckySearch:', err)
      })
    },

    mystar: function () {
      // Vérifier s'il y a un cookie mystar
      const mystarCookie = this.$cookie.get('mystar') || '0424' // default to 3562 Polaris Star      
      console.log('Cookie mystar trouvé:', mystarCookie)
      this.luckyError = '' // Reset erreur

      // Recharger l'étoile depuis le cookie
      swh.lookupSkySourceByHR(mystarCookie).then(ss => {
        if (ss) {
          console.log('Étoile rechargée depuis le cookie:', ss)
          this.$emit('input', ss)
        } else {
          console.log("Étoile du cookie non trouvée")
        }
      }).catch(err => {
        console.error("Erreur lors du rechargement de l'étoile du cookie:", err)
      })
    },
    showLuckyStarAtIndex: function (idx) {
      if (!this.luckyStarsSet || !this.luckyStarsSet.length) return
      const star = this.luckyStarsSet[idx]
      if (star.hr) {
        swh.lookupSkySourceByName(star.commonName).then(fullObj => {
          this.sourceClicked(fullObj)
        }).catch(err => {
          console.error('Erreur lors du lookupSkySourceByName:', err)
        })
      }
    },
    prevLuckyStar: function () {
      if (this.luckyStarsSetIndex > 0) {
        this.luckyStarsSetIndex--
        localStorage.setItem('luckyStarsSetIndex', this.luckyStarsSetIndex.toString())
        this.showLuckyStarAtIndex(this.luckyStarsSetIndex)
      }
    },
    nextLuckyStar: function () {
      if (this.luckyStarsSetIndex < this.luckyStarsSet.length - 1) {
        this.luckyStarsSetIndex++
        localStorage.setItem('luckyStarsSetIndex', this.luckyStarsSetIndex.toString())
        this.showLuckyStarAtIndex(this.luckyStarsSetIndex)
      }
    },
    loadLuckyStarsSet: function () {
      const set = JSON.parse(localStorage.getItem('luckyStarsSet') || '[]')
      const idx = parseInt(localStorage.getItem('luckyStarsSetIndex') || '0', 10)
      this.luckyStarsSet = set
      this.luckyStarsSetIndex = isNaN(idx) ? 0 : idx
      if (set.length) {
        this.showLuckyStarAtIndex(this.luckyStarsSetIndex)
      }
    }
  },
  mounted() {
    var that = this
    this.loadLuckyStarsSet()
    const onClick = e => {
      if (that.searchText !== '') {
        that.searchText = ''
      }
    }
    const guiParent = document.querySelector('stel') || document.body
    guiParent.addEventListener('click', onClick, false)
    EventBus.$on('lucky-search', this.luckySearch)
  },
  beforeDestroy() {
    EventBus.$off('lucky-search', this.luckySearch)
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}
</script>

<style>
.search-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 1000;
  background: #222c;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 0 0 8px 8px;
}

.lucky-arrow-btn {
  border-radius: 50%;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.08);
}

.lucky-arrow-btn:hover:not([disabled]) {
  background: #1976d2 !important;
  color: #fff !important;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.18);
}

.lucky-arrow-btn .v-icon {
  font-size: 32px !important;
}
</style>
